import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=063bd09e&scoped=true&"
import script from "./CommentInput.vue?vue&type=script&lang=js&"
export * from "./CommentInput.vue?vue&type=script&lang=js&"
import style0 from "./CommentInput.vue?vue&type=style&index=0&id=063bd09e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063bd09e",
  null
  
)

export default component.exports